import type { Rect } from '@blocksuite/global/gfx';
import type { BlockComponent } from '@blocksuite/std';
import type { BlockModel } from '@blocksuite/store';

export interface EditingState {
  element: BlockComponent;
  model: BlockModel;
  rect: DOMRect;
}

/**
 * Returns a flag for the drop target.
 */
export enum DropFlags {
  Normal,
  Database,
  EmptyDatabase,
}

/**
 * A drop placement.
 *
 * `column-before` / `column-after` put the dragged content side by side with
 * the target, in an `affine:columns` row.
 */
export type DropPlacement =
  | 'none'
  | 'before'
  | 'after'
  | 'database'
  | 'in'
  | 'column-before'
  | 'column-after';

export type DropTarget = {
  placement: DropPlacement;
  rect: Rect;
  modelState: EditingState;
};
